export default "__VITE_ASSET__D7VwVDb___"